import { Vector3 as o } from "three";
const n = new o();
function i(r, e = new o()) {
  return e.fromArray(r[1]).sub(n.fromArray(r[0])).normalize();
}
export {
  i as getLineDirection
};
//# sourceMappingURL=index8.js.map
